<template>
  <form v-on:submit.prevent="submit">
    <RFormSection>
      <RFormField>
        <RFieldLabel :isError="fields.email.error">Email</RFieldLabel>
        <input
          type="text"
          v-model="fields.email.value"
          class="container-full"
          :class="{ error: fields.email.error }"
        />
      </RFormField>
    </RFormSection>
    <RFormSection title="Сосуд">
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_agent_container.error"
          >Тип модуля</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_agent_container.value"
          class="container-full"
          :class="{ error: fields.cylinder_agent_container.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_serial_number.error"
          >Серийный номер сосуда</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_serial_number.value"
          class="container-full"
          :class="{ error: fields.cylinder_serial_number.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_nano_protection.error"
          >Защита нано составом</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_nano_protection.value"
          class="container-full"
          :class="{ error: fields.cylinder_nano_protection.error }"
        />
      </RFormField>

      <!-- <RFormField>
        <RFieldLabel :isError="fields.cylinder_test_date.error"
          >Дата испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.cylinder_test_date.value"
          :config="fields.cylinder_test_date.config"
          class="flatpickr"
          :class="{ error: fields.cylinder_test_date.error }"
        ></flat-pickr>
      </RFormField> -->
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_test_start_test_date.error"
          >Дата начала испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.cylinder_test_start_test_date.value"
          :config="fields.cylinder_test_start_test_date.config"
          class="flatpickr"
          :class="{ error: fields.cylinder_test_start_test_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_test_start_test_pressure.error"
          >Давление в начале испытаний МПа</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_test_start_test_pressure.value"
          class="container-full"
          :class="{ error: fields.cylinder_test_start_test_pressure.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_test_end_test_date.error"
          >Дата окончания испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.cylinder_test_end_test_date.value"
          :config="fields.cylinder_test_end_test_date.config"
          class="flatpickr"
          :class="{ error: fields.cylinder_test_end_test_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_test_end_test_pressure.error"
          >Давление в конце испытаний МПа</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_test_end_test_pressure.value"
          class="container-full"
          :class="{ error: fields.cylinder_test_end_test_pressure.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_test_total_test_time.error"
          >Общее время испытаний</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_test_total_test_time.value"
          class="container-full"
          :class="{ error: fields.cylinder_test_total_test_time.error }"
        />
      </RFormField>

      <RFormField>
        <RFieldLabel :isError="fields.cylinder_production_date.error"
          >Дата выпуска</RFieldLabel
        >
        <flat-pickr
          v-model="fields.cylinder_production_date.value"
          :config="fields.cylinder_production_date.config"
          class="flatpickr"
          :class="{ error: fields.cylinder_production_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_next_date_inspection.error"
          >Дата следующего освидетельствования</RFieldLabel
        >
        <flat-pickr
          v-model="fields.cylinder_next_date_inspection.value"
          :config="fields.cylinder_next_date_inspection.config"
          class="flatpickr"
          :class="{ error: fields.cylinder_next_date_inspection.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.cylinder_file.error"
          >Фото страницы паспорта</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.cylinder_file.value"
          class="container-full"
          :class="{ error: fields.cylinder_file.error }"
        />
      </RFormField>
    </RFormSection>

    <RFormSection title="Зпу">
      <RFormField>
        <RFieldLabel :isError="fields.valve_serial_number.error"
          >Серийный номер зпу</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.valve_serial_number.value"
          class="container-full"
          :class="{ error: fields.valve_serial_number.error }"
        />
      </RFormField>

      <!-- <RFormField>
        <RFieldLabel :isError="fields.valve_test_date.error"
          >Дата испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.valve_test_date.value"
          :config="fields.valve_test_date.config"
          class="flatpickr"
          :class="{ error: fields.valve_test_date.error }"
        ></flat-pickr>
      </RFormField> -->
      <RFormField>
        <RFieldLabel :isError="fields.valve_test_start_test_date.error"
          >Дата начала испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.valve_test_start_test_date.value"
          :config="fields.valve_test_start_test_date.config"
          class="flatpickr"
          :class="{ error: fields.valve_test_start_test_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.valve_test_start_test_pressure.error"
          >Давление в начале испытаний МПа</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.valve_test_start_test_pressure.value"
          class="container-full"
          :class="{ error: fields.valve_test_start_test_pressure.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.valve_test_end_test_date.error"
          >Дата окончания испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.valve_test_end_test_date.value"
          :config="fields.valve_test_end_test_date.config"
          class="flatpickr"
          :class="{ error: fields.valve_test_end_test_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.valve_test_end_test_pressure.error"
          >Давление в конце испытаний МПа</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.valve_test_end_test_pressure.value"
          class="container-full"
          :class="{ error: fields.valve_test_end_test_pressure.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.valve_test_total_test_time.error"
          >Общее время испытаний</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.valve_test_total_test_time.value"
          class="container-full"
          :class="{ error: fields.valve_test_total_test_time.error }"
        />
      </RFormField>

      <RFormField>
        <RFieldLabel :isError="fields.valve_production_date.error"
          >Дата выпуска</RFieldLabel
        >
        <flat-pickr
          v-model="fields.valve_production_date.value"
          :config="fields.valve_production_date.config"
          class="flatpickr"
          :class="{ error: fields.valve_production_date.error }"
        ></flat-pickr>
      </RFormField>
    </RFormSection>

    <RFormSection title="Манометр">
      <RFormField>
        <RFieldLabel :isError="fields.pressure_gauge_serial_number.error"
          >Серийный манометра</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.pressure_gauge_serial_number.value"
          class="container-full"
          :class="{ error: fields.pressure_gauge_serial_number.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.pressure_gauge_date_inspection.error"
          >Дата поверки</RFieldLabel
        >
        <flat-pickr
          v-model="fields.pressure_gauge_date_inspection.value"
          :config="fields.pressure_gauge_date_inspection.config"
          class="flatpickr"
          :class="{ error: fields.pressure_gauge_date_inspection.error }"
        ></flat-pickr>
      </RFormField>
    </RFormSection>

    <RFormSection title="модуль">
      <RFormField>
        <RFieldLabel :isError="fields.module_serial_number.error"
          >Серийный модуля</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.module_serial_number.value"
          class="container-full"
          :class="{ error: fields.module_serial_number.error }"
        />
      </RFormField>
      <!-- <RFormField>
        <RFieldLabel :isError="fields.module_test_date.error"
          >Дата испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.module_test_date.value"
          :config="fields.module_test_date.config"
          class="flatpickr"
          :class="{ error: fields.module_test_date.error }"
        ></flat-pickr>
      </RFormField> -->
      <RFormField>
        <RFieldLabel :isError="fields.module_test_start_test_date.error"
          >Дата начала испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.module_test_start_test_date.value"
          :config="fields.module_test_start_test_date.config"
          class="flatpickr"
          :class="{ error: fields.module_test_start_test_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.module_test_start_test_pressure.error"
          >Давление в начале испытаний МПа</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.module_test_start_test_pressure.value"
          class="container-full"
          :class="{ error: fields.module_test_start_test_pressure.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.module_test_end_test_date.error"
          >Дата окончания испытаний</RFieldLabel
        >
        <flat-pickr
          v-model="fields.module_test_end_test_date.value"
          :config="fields.module_test_end_test_date.config"
          class="flatpickr"
          :class="{ error: fields.module_test_end_test_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.module_test_end_test_pressure.error"
          >Давление в конце испытаний МПа</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.module_test_end_test_pressure.value"
          class="container-full"
          :class="{ error: fields.module_test_end_test_pressure.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.module_test_total_test_time.error"
          >Общее время испытаний</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.module_test_total_test_time.value"
          class="container-full"
          :class="{ error: fields.module_test_total_test_time.error }"
        />
      </RFormField>

      <RFormField>
        <RFieldLabel :isError="fields.module_empty_weight.error"
          >Масса пустого модуля</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.module_empty_weight.value"
          class="container-full"
          :class="{ error: fields.module_empty_weight.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.module_file.error"
          >Фото страницы паспорта</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.module_file.value"
          class="container-full"
          :class="{ error: fields.module_file.error }"
        />
      </RFormField>
    </RFormSection>

    <RFormSection title="Наполенние">
      <RFormField>
        <RFieldLabel :isError="fields.filling_сlean_аgent.error"
          >Тип ГОТВ</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.filling_сlean_аgent.value"
          class="container-full"
          :class="{ error: fields.filling_сlean_аgent.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.filling_clean_agent_weight.error"
          >Масса ГОТВ</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.filling_clean_agent_weight.value"
          class="container-full"
          :class="{ error: fields.filling_clean_agent_weight.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.filling_date.error"
          >Дата заправки</RFieldLabel
        >
        <flat-pickr
          v-model="fields.filling_date.value"
          :config="fields.filling_date.config"
          class="flatpickr"
          :class="{ error: fields.filling_date.error }"
        ></flat-pickr>
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.filling_total_weight.error"
          >Масса заправленнного модуля</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.filling_total_weight.value"
          class="container-full"
          :class="{ error: fields.filling_total_weight.error }"
        />
      </RFormField>
      <RFormField>
        <RFieldLabel :isError="fields.filling_file.error"
          >Фото страницы паспорта</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.filling_file.value"
          class="container-full"
          :class="{ error: fields.filling_file.error }"
        />
      </RFormField>
    </RFormSection>

    <RFormSection>
      <RFormField>
        <RFieldLabel :isError="fields.url_manufacture.error"
          >Ссылка на внутренние чек листы</RFieldLabel
        >
        <input
          type="text"
          v-model="fields.url_manufacture.value"
          class="container-full"
          :class="{ error: fields.url_manufacture.error }"
        />
      </RFormField>
    </RFormSection>
  </form>
</template>

<script>
import robonomicsVC from "robonomics-vc";
import "filepond/dist/filepond.min.css";
import flatPickr from "vue-flatpickr-component";
import { Russian } from "flatpickr/dist/l10n/ru.js";

export default {
  mixins: [robonomicsVC.mixins.form],
  components: {
    flatPickr
  },
  data() {
    return {
      upload: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          if (
            Object.prototype.hasOwnProperty.call(this.fields, fieldName) &&
            Object.prototype.hasOwnProperty.call(
              this.fields[fieldName],
              "value"
            )
          ) {
            this.fields[fieldName].value = file;
          } else {
            this.fields[fieldName].items[file.name] = file;
          }
          load();
          return {
            abort: () => {
              abort();
            }
          };
        },
        revert: null
      },
      fields: {
        email: {
          value: "",
          type: "text",
          rules: [
            function(v) {
              return (
                !robonomicsVC.validators.require(v) || /\S+@\S+\.\S+/.test(v)
              );
            }
          ],
          error: false
        },
        cylinder_agent_container: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        cylinder_serial_number: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        cylinder_nano_protection: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        // cylinder_test_date: {
        //   value: "",
        //   type: "datepicker",
        //   rules: ["require"],
        //   error: false,
        //   config: {
        //     dateFormat: "d.m.Y",
        //     locale: Russian
        //   }
        // },

        cylinder_test_start_test_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        cylinder_test_start_test_pressure: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        cylinder_test_end_test_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        cylinder_test_end_test_pressure: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        cylinder_test_total_test_time: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },

        // {
        //   "suffix": "/cylinder_test_start_test_date",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/cylinder_test_start_test_pressure",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/cylinder_test_end_test_date",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/cylinder_test_end_test_pressure",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/cylinder_test_total_test_time",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },

        cylinder_production_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        cylinder_next_date_inspection: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        cylinder_file: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        valve_serial_number: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        // valve_test_date: {
        //   value: "",
        //   type: "datepicker",
        //   rules: ["require"],
        //   error: false,
        //   config: {
        //     dateFormat: "d.m.Y",
        //     locale: Russian
        //   }
        // },

        valve_test_start_test_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        valve_test_start_test_pressure: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        valve_test_end_test_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        valve_test_end_test_pressure: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        valve_test_total_test_time: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },

        //     {
        //   "suffix": "/valve_test_start_test_date",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/valve_test_start_test_pressure",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/valve_test_end_test_date",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/valve_test_end_test_pressure",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/valve_test_total_test_time",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },

        valve_production_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        pressure_gauge_serial_number: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        pressure_gauge_date_inspection: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        module_serial_number: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        // module_test_date: {
        //   value: "",
        //   type: "datepicker",
        //   rules: ["require"],
        //   error: false,
        //   config: {
        //     dateFormat: "d.m.Y",
        //     locale: Russian
        //   }
        // },
        module_test_start_test_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        module_test_start_test_pressure: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        module_test_end_test_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        module_test_end_test_pressure: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        module_test_total_test_time: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },

        //     {
        //   "suffix": "/module_test_start_test_date",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/module_test_start_test_pressure",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/module_test_end_test_date",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/module_test_end_test_pressure",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },
        // {
        //   "suffix": "/module_test_total_test_time",
        //   "rosbag_type": "std_msgs/String",
        //   "data_type": "String"
        // },

        module_empty_weight: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        module_file: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        filling_сlean_аgent: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        filling_clean_agent_weight: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        filling_date: {
          value: "",
          type: "datepicker",
          rules: ["require"],
          error: false,
          config: {
            dateFormat: "d.m.Y",
            locale: Russian
          }
        },
        filling_total_weight: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        filling_file: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        },
        url_manufacture: {
          value: "",
          type: "text",
          rules: ["require"],
          error: false
        }
      }
    };
  }
};
</script>
